__turbopack_context__.v({
  "label": "FormInput-module-scss-module__RCp79a__label",
});
